import { MARKER_ICON_NAMES } from './marker-icon.js';
import type { PropRule } from './analytics-types.js';

export function markerEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const icon = new Set(MARKER_ICON_NAMES);
  return {
    marker_picker_opened: { ...common },
    marker_picker_searched: { ...common },
    marker_picker_category_changed: { ...common, category: new Set(['all', 'symbols', 'landmarks', 'buildings']), action: new Set(['filter', 'expand', 'collapse']) },
    marker_picker_closed: { ...common, outcome: new Set(['selected', 'upgrade', 'dismissed']) },
    marker_icon_attempted: { ...common, icon, outcome: new Set(['selected', 'upgrade']) },
    marker_placed: { ...common, icon },
  };
}
